import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getSettings } from "./api";

const DEFAULTS = {
  marquee_speed: 40,
  company_name: "Arnav Enterprises",
  tagline: "Renewable Energy Solution Provider",
  logo_url: "",
  hero_bg_url: "",
  whatsapp_number: "919503935678",
  notify_email: "",
  shop_address: "Gaddam Plot, Ashirwad Bhavan,\nNear Mulawalkar Hospital,\nAkola, Maharashtra",
  shop_phone: "+91 95039 35678",
  shop_email: "info@arnavsolar.in",
  shop_hours: "Mon–Sat: 10:00 AM – 8:00 PM",
  map_query: "Mulawalkar Hospital, Akola, Maharashtra",
};

const SettingsContext = createContext({ settings: DEFAULTS, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const data = await getSettings();
      setSettings({ ...DEFAULTS, ...data });
    } catch (e) {
      // ignore, keep defaults
    }
  }, []);

  useEffect(() => {
    refresh();
    const onChange = () => refresh();
    window.addEventListener("arnav-settings-change", onChange);
    return () => window.removeEventListener("arnav-settings-change", onChange);
  }, [refresh]);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>{children}</SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}

export function AddressLines({ text, ...rest }) {
  const lines = (text || "").split("\n").filter(Boolean);
  return (
    <span {...rest}>
      {lines.map((l, i) => (
        <span key={i}>
          {l}
          {i < lines.length - 1 && <br />}
        </span>
      ))}
    </span>
  );
}
